import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { ActivatedRoute } from '@angular/router';
import { Noticia } from '../shared/model/noticia.model';
import { NotificationService } from '../shared/messages/notification.service';
import { Imagem } from '../shared/model/imagem.model';

@Component({
  selector: 'app-noticia-detalhe',
  templateUrl: './noticia-detalhe.component.html',
  styleUrls: ['./noticia-detalhe.component.css']
})
export class NoticiaDetalheComponent implements OnInit {

  // @ViewChild('Slider') slideEL: ElementRef;
  public noticia: Noticia;
  public conteudo: string;

  constructor(private service: CMSPortalService,
              private route: ActivatedRoute,
              @Inject('CMS_HOST') private host: string) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.carregaNoticia(params['id']);
      } else {
        this.carregaUltimaNoticia();
      }
    });
  }

  carregaNoticia(id: string) {
    this.service.getNoticia(id).subscribe(res => {
      const n = res.conteudo[0];
      n.imagens.sort((a, b) => a.capa > b.capa ? -1 : a.capa < b.capa ? 1 : 0);
      this.noticia = n;
    });
  }

  carregaUltimaNoticia() {
    this.service.getUltimaNoticia().subscribe(res => {
      const n = res.conteudo;
      n.imagens.sort((a, b) => a.capa > b.capa ? -1 : a.capa < b.capa ? 1 : 0);
      this.noticia = n;
    });
  }

  carregarImagem(imagem: Imagem): string {
    return this.host + imagem.url;
  }

  /*carregarSlider() {
    const fragment = document.createRange().createContextualFragment(
      '<script type="text/javascript">' +
        '$("#Fader").easyFader({' +
        '   slideDur: 6000,' +
        '   fadeDur: 800' +
      ' });' +
      '</script>');
    this.slideEL.nativeElement.appendChild(fragment);
  }*/

}
